/**
 * Traffic cone icon styled for maintenance messaging (banner, settings, public page).
 */

import { Icon } from '@components/Icon';
import type { IconSize } from '@design-tokens/icons';

import './MaintenanceTrafficConeIcon.css';

export interface MaintenanceTrafficConeIconProps {
  size?: IconSize;
  className?: string;
}

export function MaintenanceTrafficConeIcon({
  size = 'md',
  className = '',
}: MaintenanceTrafficConeIconProps) {
  return (
    <Icon
      type="traffic-cone"
      style="filled"
      backgroundShape="rounded-square"
      colorVariant="orange"
      size={size}
      className={className ? `bhg-traffic-cone-icon ${className}` : 'bhg-traffic-cone-icon'}
      aria-hidden
    />
  );
}
